import { css } from 'lit';

export const styles = css `
  :host {
    position: relative;
    display: block;
    --_active-color: var(--u-tab-active-color, var(--u-color-primary, rgb(103, 80, 164)));
    --_active-label-color: var(--u-tab-active-label-color, var(--u-color-primary, rgb(103, 80, 164)));
    overflow: hidden;
  }

  .container {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
    min-height: var(--u-tab-bar-min-height, 48px);
    overflow: auto;
    scroll-padding-inline: 128px;
    scrollbar-width: none;
  }
  .container::-webkit-scrollbar {
    display: none;
  }

  .scroll-indicator {
    --u-elevation-level: 2;
    cursor: pointer;
    position: absolute;
    display: none;
    align-items: center;
    justify-content: center;
    top: 0;
    width: var(--u-tab-bar-scroll-indicator-size, 32px);
    background-color: var(--u-scroll-indicator-bg-color, var(--u-current-bg-color, var(--u-color-surface, rgb(254, 247, 255))));
    font-size: 1.5rem;
    height: 100%;
    z-index: 1;
  }
  @media (hover: hover) {
    :host(:hover) .scroll-indicator.active {
      display: flex;
    }
  }

  .scroll-left {
    left: 0;
  }

  .scroll-right {
    right: 0;
  }

  .tab-indicator {
    position: absolute;
    background-color: var(--_active-color);
    height: 3px;
    bottom: 0;
    transition: inset 200ms ease-out, width 200ms ease-out;
  }

  .container:not(.secondary) .tab-indicator {
    border-radius: var(--u-tab-bar-primary-border-radius, 9999px 9999px 0 0);
  }

  .secondary {
    --_active-label-color: var(--u-tab-secondary-active-label-color, var(--u-color-on-surface, rgb(29, 27, 32)));
    --_tab-content-direction: row;
    --_tab-content-gap: 8px;
    --u-tab-with-icon-height: var(--u-tab-secondary-with-icon-height, 48px);
  }
`;
